const siteUrl = 'https://multiversetools.in';

// Homepage schemas
export const homeSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "MultiverseTools",
    "url": siteUrl,
    "logo": `${siteUrl}/logo.png`,
    "sameAs": [
      "https://twitter.com/yourhandle",
      "https://facebook.com/yourpage",
      "https://instagram.com/yourhandle"
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "MultiverseTools",
    "url": siteUrl,
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${siteUrl}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Online Tools",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Image Tools", "url": `${siteUrl}/image-tools` },
      { "@type": "ListItem", "position": 2, "name": "PDF Tools", "url": `${siteUrl}/pdf-tools` },
      { "@type": "ListItem", "position": 3, "name": "Video Tools", "url": `${siteUrl}/video-tools` }
    ]
  }
];

// Hub page schemas
export const imageToolsSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Image Tools Hub",
    "url": `${siteUrl}/image-tools`,
    "description": "Free online image tools to convert, compress, crop and encode images.",
    "isPartOf": { "@type": "WebSite", "url": siteUrl }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "Image Tools", "item": `${siteUrl}/image-tools` }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Image Converter", "url": `${siteUrl}/image-converter` },
      { "@type": "ListItem", "position": 2, "name": "Image Compressor", "url": `${siteUrl}/image-compressor` },
      { "@type": "ListItem", "position": 3, "name": "Image Cropper", "url": `${siteUrl}/image-cropper` },
      { "@type": "ListItem", "position": 4, "name": "Base64 Converter", "url": `${siteUrl}/base64-converter` }
    ]
  }
];

export const pdfToolsSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "PDF Tools Hub",
    "url": `${siteUrl}/pdf-tools`,
    "description": "Free online PDF tools to merge, split, compress, convert and organize PDF files.",
    "isPartOf": { "@type": "WebSite", "url": siteUrl }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "PDF Tools", "item": `${siteUrl}/pdf-tools` }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Compress PDF", "url": `${siteUrl}/compress-pdf` },
      { "@type": "ListItem", "position": 2, "name": "Text to PDF", "url": `${siteUrl}/text-to-pdf` },
      { "@type": "ListItem", "position": 3, "name": "Merge PDF", "url": `${siteUrl}/pdf-merge` },
      { "@type": "ListItem", "position": 4, "name": "Split PDF", "url": `${siteUrl}/pdf-split` },
      { "@type": "ListItem", "position": 5, "name": "PDF to Images", "url": `${siteUrl}/pdf-to-images` },
      { "@type": "ListItem", "position": 6, "name": "PDF Watermark", "url": `${siteUrl}/pdf-watermark` },
      { "@type": "ListItem", "position": 7, "name": "Organize PDF", "url": `${siteUrl}/pdf-organize` }
    ]
  }
];

export const videoToolsSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Video Tools Hub",
    "url": `${siteUrl}/video-tools`,
    "description": "Free online video tools to convert, compress and edit video files.",
    "isPartOf": { "@type": "WebSite", "url": siteUrl }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "Video Tools", "item": `${siteUrl}/video-tools` }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Video to Audio", "url": `${siteUrl}/video-to-audio` },
      { "@type": "ListItem", "position": 2, "name": "Video to GIF", "url": `${siteUrl}/video-to-gif` },
      { "@type": "ListItem", "position": 3, "name": "Remove Audio from Video", "url": `${siteUrl}/video-audio-remover` },
      { "@type": "ListItem", "position": 4, "name": "Video Compressor", "url": `${siteUrl}/video-compressor` }
    ]
  }
];

// Image tool schemas
export const imageConverterSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Image Converter",
    "url": `${siteUrl}/image-converter`,
    "description": "Convert images between JPG, PNG, WEBP, GIF and more formats online free.",
    "applicationCategory": "MultimediaApplication",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "Image Tools", "item": `${siteUrl}/image-tools` },
      { "@type": "ListItem", "position": 3, "name": "Image Converter", "item": `${siteUrl}/image-converter` }
    ]
  }
];

export const imageCompressorSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Image Compressor",
    "url": `${siteUrl}/image-compressor`,
    "description": "Compress JPG, PNG and WEBP images online without losing quality.",
    "applicationCategory": "MultimediaApplication",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "Image Tools", "item": `${siteUrl}/image-tools` },
      { "@type": "ListItem", "position": 3, "name": "Image Compressor", "item": `${siteUrl}/image-compressor` }
    ]
  }
];

export const imageCropperSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Image Cropper",
    "url": `${siteUrl}/image-cropper`,
    "description": "Crop and resize JPG, PNG and WEBP images online free.",
    "applicationCategory": "MultimediaApplication",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "Image Tools", "item": `${siteUrl}/image-tools` },
      { "@type": "ListItem", "position": 3, "name": "Image Cropper", "item": `${siteUrl}/image-cropper` }
    ]
  }
];

export const base64ConverterSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Base64 Converter",
    "url": `${siteUrl}/base64-converter`,
    "description": "Convert images to Base64 or decode Base64 to image instantly online free.",
    "applicationCategory": "DeveloperApplication",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "Image Tools", "item": `${siteUrl}/image-tools` },
      { "@type": "ListItem", "position": 3, "name": "Base64 Converter", "item": `${siteUrl}/base64-converter` }
    ]
  }
];

// PDF tool schemas
export const compressPdfSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Compress PDF",
    "url": `${siteUrl}/compress-pdf`,
    "description": "Reduce PDF file size online without losing quality.",
    "applicationCategory": "Utility",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "PDF Tools", "item": `${siteUrl}/pdf-tools` },
      { "@type": "ListItem", "position": 3, "name": "Compress PDF", "item": `${siteUrl}/compress-pdf` }
    ]
  }
];

export const textToPdfSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Text to PDF Converter",
    "url": `${siteUrl}/text-to-pdf`,
    "description": "Convert plain text to a PDF document online free.",
    "applicationCategory": "Utility",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "PDF Tools", "item": `${siteUrl}/pdf-tools` },
      { "@type": "ListItem", "position": 3, "name": "Text to PDF", "item": `${siteUrl}/text-to-pdf` }
    ]
  }
];

export const pdfMergeSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Merge PDF",
    "url": `${siteUrl}/pdf-merge`,
    "description": "Combine multiple PDF files into one document online free.",
    "applicationCategory": "Utility",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "PDF Tools", "item": `${siteUrl}/pdf-tools` },
      { "@type": "ListItem", "position": 3, "name": "Merge PDF", "item": `${siteUrl}/pdf-merge` }
    ]
  }
];

export const pdfSplitSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Split PDF",
    "url": `${siteUrl}/pdf-split`,
    "description": "Split a PDF into multiple files or extract specific pages online free.",
    "applicationCategory": "Utility",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "PDF Tools", "item": `${siteUrl}/pdf-tools` },
      { "@type": "ListItem", "position": 3, "name": "Split PDF", "item": `${siteUrl}/pdf-split` }
    ]
  }
];

export const pdfToImagesSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "PDF to Images",
    "url": `${siteUrl}/pdf-to-images`,
    "description": "Convert PDF pages to high-quality JPG or PNG images online free.",
    "applicationCategory": "Utility",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "PDF Tools", "item": `${siteUrl}/pdf-tools` },
      { "@type": "ListItem", "position": 3, "name": "PDF to Images", "item": `${siteUrl}/pdf-to-images` }
    ]
  }
];

export const pdfWatermarkSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "PDF Watermark",
    "url": `${siteUrl}/pdf-watermark`,
    "description": "Add text or image watermarks to PDF files online free.",
    "applicationCategory": "Utility",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "PDF Tools", "item": `${siteUrl}/pdf-tools` },
      { "@type": "ListItem", "position": 3, "name": "PDF Watermark", "item": `${siteUrl}/pdf-watermark` }
    ]
  }
];

export const pdfOrganizeSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Organize PDF",
    "url": `${siteUrl}/pdf-organize`,
    "description": "Rearrange, delete or reorder PDF pages online free.",
    "applicationCategory": "Utility",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "PDF Tools", "item": `${siteUrl}/pdf-tools` },
      { "@type": "ListItem", "position": 3, "name": "Organize PDF", "item": `${siteUrl}/pdf-organize` }
    ]
  }
];

// Video tool schemas
export const videoToAudioSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Video to Audio Converter",
    "url": `${siteUrl}/video-to-audio`,
    "description": "Extract audio from any video file online free — convert video to MP3 or WAV.",
    "applicationCategory": "MultimediaApplication",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "Video Tools", "item": `${siteUrl}/video-tools` },
      { "@type": "ListItem", "position": 3, "name": "Video to Audio", "item": `${siteUrl}/video-to-audio` }
    ]
  }
];

export const videoToGifSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Video to GIF Converter",
    "url": `${siteUrl}/video-to-gif`,
    "description": "Convert video clips to high-quality GIF online free.",
    "applicationCategory": "MultimediaApplication",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "Video Tools", "item": `${siteUrl}/video-tools` },
      { "@type": "ListItem", "position": 3, "name": "Video to GIF", "item": `${siteUrl}/video-to-gif` }
    ]
  }
];

export const videoAudioRemoverSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Remove Audio from Video",
    "url": `${siteUrl}/video-audio-remover`,
    "description": "Mute or remove the audio track from any video online free.",
    "applicationCategory": "MultimediaApplication",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "Video Tools", "item": `${siteUrl}/video-tools` },
      { "@type": "ListItem", "position": 3, "name": "Remove Audio from Video", "item": `${siteUrl}/video-audio-remover` }
    ]
  }
];

export const videoCompressorSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Video Compressor",
    "url": `${siteUrl}/video-compressor`,
    "description": "Compress large video files online without losing quality.",
    "applicationCategory": "MultimediaApplication",
    "operatingSystem": "Any (Browser-based)",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
      { "@type": "ListItem", "position": 2, "name": "Video Tools", "item": `${siteUrl}/video-tools` },
      { "@type": "ListItem", "position": 3, "name": "Video Compressor", "item": `${siteUrl}/video-compressor` }
    ]
  }
];
